/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ActionConstraintHasAllValid = core.serialization.object({
    ignoreSelection: core.serialization.boolean().optional(),
});
